/* eslint-disable react/jsx-props-no-spreading */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import { FlowsListingPage } from 'next/pages/flows';
import { SettingsPage as MobileSettingsPage } from 'next/pages/mobile';
// TODO: Migrate page components to `/pages`
import { AccountsPage } from 'next/components/Accounts';
// TODO: Migrate page components to `/pages`
import { PinsPage, SettingsPage, AnalyticsPage } from 'next/components/Pins';
import {
  selectFeatures,
  NEXT_FLOWS_LIST_PAGE,
  NEW_NAV,
  PINS_BETA,
  PINS,
  MOBILE_FLOWS,
} from 'next/entities/features';
import TemporaryLayout from 'next/pages/TemporaryLayout';
import { SignupInfo } from 'next/pages/SignupInfo';
import useListeners from './use-listeners';

/**
 * Shareable route registry
 *
 * NOTE: In the future, we can inline the parameters directly as props to
 *       <Route>, but since we need to create conditional passthrough routes in
 *       legacy studio as well, we need to define these routes in a way it can
 *       be consumed in multiple places
 *
 * FIXME: remove TemporaryLayout once we make the Nav independent from old studio
 */
export const routes = [
  {
    feature: NEXT_FLOWS_LIST_PAGE,
    path: '/flows',
    exact: true,
    render: () => {
      return (
        <TemporaryLayout>
          <FlowsListingPage />
        </TemporaryLayout>
      );
    },
  },

  {
    feature: PINS_BETA && PINS,
    path: `/pins/:pinId/settings`,
    render: () => {
      return (
        <TemporaryLayout>
          <SettingsPage />
        </TemporaryLayout>
      );
    },
  },
  {
    feature: PINS_BETA && PINS,
    path: '/pins/:pinId/analytics',
    render: () => {
      return (
        <TemporaryLayout>
          <AnalyticsPage />
        </TemporaryLayout>
      );
    },
  },
  {
    feature: PINS_BETA && PINS,
    path: '/pins',
    render: () => {
      return (
        <TemporaryLayout>
          <PinsPage />
        </TemporaryLayout>
      );
    },
  },

  {
    feature: NEW_NAV,
    path: '/accounts',
    render: () => {
      return <AccountsPage size="full" />;
    },
  },
  {
    feature: MOBILE_FLOWS,
    path: '/mobile/flows/:experienceId/settings',
    render: () => {
      return (
        <TemporaryLayout>
          <MobileSettingsPage />
        </TemporaryLayout>
      );
    },
  },
  {
    enabled: true,
    path: '/signup_info',
    render: () => <SignupInfo />,
  },
];

/**
 * Filter accessible routes based on feature flags
 *
 * @param {Route[]} registry - List of registered routes
 * @param {object<boolean>} features - Map of feature flags
 * @return {Route[]} Filtered list of routes
 */
export const filter = (registry = [], features = {}) =>
  registry.filter(({ feature, enabled }) => enabled ?? features[feature]);

/**
 * Top-level routes for studio next
 */
export function Routes({ features = {}, routes: registry = routes }) {
  const accessible = filter(registry, features);

  useListeners();

  return (
    <Switch>
      {accessible.map(({ path, ...rest }) => (
        <Route key={path} path={path} {...rest} />
      ))}
    </Switch>
  );
}

Routes.propTypes = {
  features: PropTypes.objectOf(PropTypes.bool),
  routes: PropTypes.shape({
    enabled: PropTypes.bool,
    exact: PropTypes.bool,
    feature: PropTypes.bool,
    path: PropTypes.string,
    render: PropTypes.func,
  }),
};

const mapStateToProps = state => ({
  features: selectFeatures(state),
});

export default connect(mapStateToProps)(Routes);
